var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOmmnioAppIcon = function SvgOmmnioAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    rx: 3.78
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FA",
    d: "M10.01 3.667a6.34 6.34 0 0 0-3.563 1.065C4.737 5.878 3.667 7.835 3.667 10v.046c0 2.387 1.29 4.502 3.306 5.562l-.093-1.912a.87.87 0 0 0-.218-.521c-.716-.838-1.14-1.952-1.14-3.175v-.046c0-1.161.375-2.24 1.03-3.064.786-.99 1.977-1.627 3.412-1.627 2.562 0 4.513 2.134 4.513 4.737v.046c0 .63-.111 1.235-.321 1.788-.631 1.683-2.163 2.881-4.145 2.881a4.5 4.5 0 0 1-.821-.075.84.84 0 0 0-.543.09l-1.67.878a6.35 6.35 0 0 0 2.987.725c3.41 0 5.986-2.513 6.329-5.62q.041-.351.04-.713v-.046c0-3.425-2.678-6.287-6.322-6.287"
  }))));
};
export default SvgOmmnioAppIcon;